import React from 'react';
import { useDispatch, useShallowSelector } from '@/lib/reduxHooks';
import * as actions from '../../store/senderBuild/actions';

export function useBackspaceKeyListener() {
  const dispatch = useDispatch();
  const state = useShallowSelector((state) => ({
    selectedBlocks: state.senderBuild.selectedBlocks,
    isTextBlockEditingEnabled: state.senderBuild.isTextBlockEditingEnabled,
    inputFocused: state.senderBuild.inputFocused,
    isAutoSaving: state.senderBuild.isAutoSaving,
    blocks: state.senderBuild.blocks,
  }));

  React.useEffect(() => {
    function keyboardHandler(e: KeyboardEvent) {
      if (!state.selectedBlocks.blockIndices.length) return;
      const sb = state.selectedBlocks;
      if (
        !state.isTextBlockEditingEnabled &&
        !state.inputFocused &&
        !state.isAutoSaving &&
        (e.key === 'Delete' || e.key === 'Backspace')
      ) {
        e.preventDefault();
        const blockIds = sb.blockIndices.reverse().map((i) => state.blocks[sb.documentId!][sb.pageIndex!][i].blockId!);
        dispatch(actions.deleteBlocks(sb.documentId!, sb.pageIndex!, blockIds));
      }
    }

    document.addEventListener('keydown', keyboardHandler, false);
    return () => document.removeEventListener('keydown', keyboardHandler, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, [
    state.selectedBlocks.blockIndices,
    state.blocks,
    state.inputFocused,
    state.isTextBlockEditingEnabled,
    state.isAutoSaving,
  ]);
}
